// extracted by mini-css-extract-plugin
module.exports = {"item-column":"item-column--2bn4CZrebS","itemColumn":"item-column--2bn4CZrebS"};